
import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import ConfirmWithCommentModal from "@/features/shared/components/ConfirmWithCommentModal.vue";

@Component({
  components: {
        ConfirmWithCommentModal
  }
})
export default class ButtonWithConfirmAndComment extends Vue {
  @Prop({required: true})
  modalTitle!: string;

  @Prop({required: true})
  modalActionButtonText!: string;

  @Prop({required: false, default: "primary"})
  modalButtonVariant!: string;
  
  @Prop()
  confirmAction!: (comment:string) => Promise<string>;
    
  $refs!: { rejectModal: ConfirmWithCommentModal }
      
  async handleConfirm(comment: string){
    await this.confirmAction(comment);
  }
}
